<template>
  <div class="text-center h-50 d-flex">
    <v-progress-circular
      :size="loaderSize"
      :width="loaderWidth"
      color="itemis-analyze-primary ma-auto"
      indeterminate
    />
  </div>
</template>

<script lang="ts" setup>
  defineProps({
    loaderSize: { type: Number, default: 50, required: false },
    loaderWidth: { type: Number, default: 7, required: false },
  })
</script>
